var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 309.5V96c0-35.35-28.65-64-64-64H64.01C28.66 32 .0065 60.65 .0065 96L0 416c0 35.35 28.65 64 64 64h213.5c16.97 0 33.25-6.742 45.26-18.75l106.5-106.5C441.3 342.7 448 326.5 448 309.5zM300.1 438.6C296.7 442.1 292.5 444.4 288 445.9V336c0-8.828 7.188-16 16-16h109.9c-1.566 4.477-3.844 8.668-7.297 12.12L300.1 438.6zM416 288h-112C277.5 288 256 309.5 256 336V448H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32V288z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.62cbbeb388b158cc5edfefe8268b23f4.svg";
export { ForwardRef as ReactComponent };